import { render, staticRenderFns } from "./documento.vue?vue&type=template&id=58d75bc8&scoped=true&"
import script from "./documento.vue?vue&type=script&lang=js&"
export * from "./documento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d75bc8",
  null
  
)

export default component.exports